export function extractDistributionOutletFromLocation(locationObj = location) {
  const params = new URLSearchParams(locationObj.search);
  const result = params.get('vertriebsstelle');
  return result ? result : '';
}
